import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import VillaBookingService from "./VillaBookingService.js";


export const getVillaBookings = createAsyncThunk("VillaBooking/get-VillaBookings", async (thunkAPI) => {
    try {
        return await VillaBookingService.getVillaBookings();
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const createVillaBooking = createAsyncThunk(
    "VillaBooking/create-VillaBookings",
    async (AssociationData, thunkAPI) => {
        try {
            return await VillaBookingService.createVillaBooking(AssociationData);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const getVillaBooking = createAsyncThunk(
    "VillaBooking/get-VillaBooking",
    async (id, thunkAPI) => {
        try {
            return await VillaBookingService.getVillaBooking(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const updateVillaBooking = createAsyncThunk(
    "VillaBooking/update-VillaBooking",
    async (id, thunkAPI) => {
        try {
            return await VillaBookingService.updateVillaBooking(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteVillaBooking = createAsyncThunk(
    "VillaBooking/delete-VillaBooking",
    async (id, thunkAPI) => {
        try {
            return await VillaBookingService.deleteVillaBooking(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const updateVillaBookingStatus = createAsyncThunk(
    "VillaBooking/update-VillaBooking-status",
    async (id, thunkAPI) => {
        try {
            return await VillaBookingService.updateVillaBookingStatus(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const resetState = createAction("Reset_all");

const initialState = {
    VillaBookings: [],
    isError: false,
    isLoading: false,
    isSuccess: false,
    message: "",
};
export const VillaBookingSlice = createSlice({
    name: "VillaBooking",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getVillaBookings.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getVillaBookings.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.VillaBookings = action.payload.bookingData;
            })
            .addCase(getVillaBookings.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(createVillaBooking.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createVillaBooking.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.createdVillaBooking = action.payload;
            })
            .addCase(createVillaBooking.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.payload;
            })

            .addCase(getVillaBooking.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getVillaBooking.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.chaptersname = action.payload.data.name;
                state.chapterspost = action.payload.data.post;
                state.chaptersabout = action.payload.data.about;
            })
            .addCase(getVillaBooking.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(updateVillaBooking.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateVillaBooking.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.updatedVillaBooking = action.payload;
            })
            .addCase(updateVillaBooking.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(deleteVillaBooking.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteVillaBooking.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.deletedVillaBooking = action.payload;
            })
            .addCase(deleteVillaBooking.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(updateVillaBookingStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateVillaBookingStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.updatedVillaBookingStatus = action.payload;
            })
            .addCase(updateVillaBookingStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(resetState, () => initialState);
    },
});
export default VillaBookingSlice.reducer;
